import React, { useState } from "react";

const NAV_LINKS = [
  { label: "HOME", href: "https://www.uslawshield.com/" },
  { label: "EDUCATE", href: "https://www.uslawshield.com/education/" },
  {
    label: "PREPARE",
    href: "https://www.uslawshield.com/seminar/",
    active: true,
  },
  { label: "PROTECT", href: "https://www.uslawshield.com/coverage/" },
  { label: "BLOG", href: "https://www.uslawshield.com/blog-2/" },
  { label: "ABOUT US", href: "https://www.uslawshield.com/about-us-2/" },
];

const USLSHeader: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header>
      {/* Top utility bar — dark navy matching uslawshield.com */}
      <div className="bg-[#1B2A4A]">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between h-10 text-sm">
          <a
            href="tel:1-877-448-6839"
            className="text-white font-medium hover:text-gray-300"
          >
            877-448-6839
          </a>
          <div className="flex items-center gap-4">
            <a
              href="https://members.uslawshield.com/"
              className="text-gray-300 hover:text-white"
            >
              Log In
            </a>
            <a
              href="https://www.uslawshield.com/member-signup/"
              className="bg-[#a51d31] text-white px-4 py-1.5 rounded text-sm font-medium hover:bg-[#8a1829] transition-colors"
            >
              Join Now &rarr;
            </a>
          </div>
        </div>
      </div>

      {/* Logo + Nav — dark background matching uslawshield.com */}
      <div className="bg-[#1B2A4A] border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between h-20">
          <a href="https://www.uslawshield.com/">
            <img
              src="/USLSlogonobackground.png"
              alt="U.S. LawShield"
              className="h-16 w-auto"
            />
          </a>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-6">
            {NAV_LINKS.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className={`text-sm font-medium tracking-wide transition-colors ${
                  link.active
                    ? "text-white border-b-2 border-[#C8102E] pb-1"
                    : "text-gray-300 hover:text-white"
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Mobile menu button */}
          <button
            type="button"
            className="md:hidden p-2 text-gray-300"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {mobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile nav */}
        {mobileMenuOpen && (
          <nav className="md:hidden border-t border-white/10 bg-[#1B2A4A] px-4 py-3 space-y-2">
            {NAV_LINKS.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className={`block py-2 text-sm font-medium ${
                  link.active ? "text-white" : "text-gray-300"
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default USLSHeader;
